// Group member-management API client — un seul client pour TOUS les types de
// groupe (projet, filiale/BU…). Le back sert /api/group/{id}/members quel que
// soit le type et déduit rôles et messages du groupe lui-même.
// CSRF and session cookies are injected by the global fetch patch
// (services/fetchPatch.js) for /api/* routes — no manual headers needed here.

/**
 * List a group's members with their per-group roles.
 * @param {number|string} groupId
 * @returns {Promise<{members: Array, availableRoles: Array, canManage: boolean}>}
 */
export async function listGroupMembers(groupId) {
  const res = await fetch(`/api/group/${groupId}/members?_=${Date.now()}`, { credentials: 'include' });
  if (!res.ok) throw await toError(res, 'Échec du chargement des membres');
  return res.json();
}

/**
 * Add an existing user to the group with the given roles.
 * @param {number|string} groupId
 * @param {{uid: number, roles: string[]}} payload
 */
export async function addGroupMember(groupId, payload) {
  const res = await fetch(`/api/group/${groupId}/members`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw await toError(res, "Échec de l'ajout du membre");
  return res.json();
}

/**
 * Replace a member's roles in the group.
 * @param {number|string} groupId
 * @param {number} uid
 * @param {string[]} roles
 */
export async function setGroupMemberRoles(groupId, uid, roles) {
  const res = await fetch(`/api/group/${groupId}/members/${uid}`, {
    method: 'PUT',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ roles }),
  });
  if (!res.ok) throw await toError(res, 'Échec de la mise à jour des rôles');
  return res.json();
}

/**
 * Remove a member from the group.
 * @param {number|string} groupId
 * @param {number} uid
 */
export async function removeGroupMember(groupId, uid) {
  const res = await fetch(`/api/group/${groupId}/members/${uid}`, {
    method: 'DELETE',
    credentials: 'include',
  });
  if (!res.ok) throw await toError(res, 'Échec du retrait du membre');
  return res.json();
}

async function toError(res, fallback) {
  const body = await res.json().catch(() => ({}));
  return new Error(body?.error || fallback);
}
